exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/src/app/admin/components/admin-orders/admin-orders.component.css
// module id = ../../../../../src/app/admin/components/admin-orders/admin-orders.component.css
// module chunks = 1